import pic61 from './assets/images/61.jpg';
import pic62 from './assets/images/62.jpg';
import pic63 from './assets/images/63.jpg';
import pic64 from './assets/images/64.jpg';

import svg22 from './assets/svg/22.svg';
import svg63 from './assets/svg/63.svg';
import svg64 from './assets/svg/64.svg';

const Six = () => (
	  <section style={{paddingTop: "1em"}}>
		<div className="section-num" style={{top: 0}}>2</div>
		<p><img src={pic61} alt="" /></p>
		<div className="wrapper">
			<h2>Když stromy ještě neexistovaly</h2>
			<p className="like-h3">V prehistorických dobách, zhruba před 400 miliony lety, vypadala příroda jinak, než jak ji známe dnes.</p>
			<p className="txt-right" style={{marginBottom: "1em"}}>
				<span className="relative inline-block" style={{maxWidth: "16em"}}>Než se vyvinuly první stromy, rostly na Zemi obří houby, které vzhledem připomínaly mohutné kmeny stromů. Měřily až 8 metrů na&nbsp;výšku a 1 metr na šířku.
					<img src={svg63} className="pointer" style={{top: "100%", right: "20%", maxWidth: "8%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic64} alt="" /></p>
		<div className="wrapper">
			<p style={{marginTop: "-.75em"}}>
				<span className="relative inline-block" style={{maxWidth: "15.5em"}}>Tyto houby se nazývají Prototaxites. Podhoubím vylučovaly do svého okolí látky, které dokázaly proniknout i skálou. Díky tomu mohli tito pravěcí velikáni získávat živiny z&nbsp;míst, kde to jiné druhy neuměly.
					<img src={svg22} className="pointer" style={{bottom: "88%", left: "75%", maxWidth: "12%"}} alt="" />
				</span>
			</p>
			<h2>Jak vzniká dřevo stromu</h2>
			<p className="like-h3">Hlavní stavební složkou dřeva dnešních&nbsp;stromů je lignin, který stromu umožňuje dřevnatění jeho buněčných stěn.</p>
			<p style={{marginBottom: "1em"}}>
				<span className="relative inline-block" style={{maxWidth: "16em"}}>Lignin obsahuje většina rostlin. Stromy ho mají ale mnohonásobně víc než třeba trávy nebo kapradiny. Díky ligninu je strom pevný, velký a odolný proti napadení škůdci.
					<img src={svg63} className="pointer" style={{top: "100%", right: "35%", maxWidth: "8%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic62} alt="" /></p>
		<div className="wrapper">
			<p style={{maxWidth: "16em", marginTop: "-1em"}}><b className="tip">Tip pro tebe:</b> Napadlo tě někdy, proč květina na&nbsp;podzim uvadá a strom ne? Dovedeš si představit, že přes 20 m vysoký topol černý, u&nbsp;kterého právě stojíš, si lehá na louku, aby&nbsp;na&nbsp;jaře znovu vyrostl?</p>
			<h2>Proč už nevzniká uhlí?</h2>
			<p className="like-h3">Když strom přece jen stářím uhyne, začnou ho postupně rozkládat bakterie, houby a dřevem se živící hmyz.</p>
			<p className="txt-right">
				<span className="relative inline-block" style={{maxWidth: "16em"}}>Než se strom přirozeně rozloží, přemění na&nbsp;humus a zcela se vrátí zpět do půdy, trvá to&nbsp;mnoho desítek let.<br />Nebylo tomu tak ale vždy.
					<img src={svg63} className="pointer" style={{top: "100%", right: "2%", maxWidth: "8%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic63} alt="" /></p>
		<div className="wrapper">
			<p className="txt-right" style={{marginTop: "-.75em"}}>
				<span className="relative inline-block" style={{maxWidth: "17.25em"}}>Trvalo několik milionů let, než se organismy naučily lignin rozkládat. Po dobu, co se to učily, vznikalo uhlí – stromy nikdo nerozkládal, a tak uhelnatěly. Až se to naučily, uhlí přestalo vznikat.
					<img src={svg64} className="pointer" style={{bottom: "100%", right: "5%", maxWidth: "30%"}} alt="" />
				</span>
			</p>
		</div>
	</section>
);

export default Six;
